import { Link } from 'react-router-dom';
import {
  DoctorSelectionSVG,
  FacilitySelectionSVG,
} from 'src/Admin/img/Admin/ProviderSelfRegistration/ProviderRegistration';

const ProviderTypeSelection = ({ selectProviderType }) => {
  return (
    <div className="">
      <div className="provider-selection d-flex ">
        <div
          className="doc-fac-selection mr-5"
          onClick={selectProviderType('Doctor')}
        >
          <div className="provider-avatar-container text-md-center d-flex flex-md-column mb-3 mb-md-0">
            <span className="provider-singleav mt-2 mt-md-0">
              <DoctorSelectionSVG />
            </span>
            <div className="content-box ml-3 ml-md-0">
              <h2 className="provider-heading">Doctor or Representative </h2>
              <p className="regprovider-descp">
                Doctor or the Representative of a Doctor can register to access
                Claims, authorizations.{' '}
              </p>
            </div>
          </div>
        </div>
        <div
          className="doc-fac-selection"
          onClick={selectProviderType('Facility')}
        >
          <div className="provider-avatar-container text-md-center d-flex flex-md-column mb-3 mb-md-0 px-md-2">
            <span className="provider-singleav mt-2 mt-md-0">
              <FacilitySelectionSVG />
            </span>
            <div className="content-box ml-3 ml-md-0">
              <h2 className="provider-heading">Facility</h2>
              <p className="regprovider-descp">
                Register as a Facility (includes hospitals, urgent care centers,
                clinics, and other places that offer treatment for illnesses,
                injuries) to access Claims, authorizations.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="provider-register-space">
        <p className="provider-select-continue d-none d-md-block">
          Select an option to continue{' '}
        </p>
        <span className="already-registered pl-3 pl-md-0">
          Already registered?
          <Link to="/admin">Login here. </Link>
        </span>
      </div>
    </div>
  );
};

export default ProviderTypeSelection;
